import type { BaseBroadcastMessage } from '@/src/services/tabSync';

export const SESSION_CHANNEL = 'session';

export enum SessionMessageType {
  // The server reported the time left (status check, "Continue Session" or a newly opened tab)
  STATE_UPDATE = 'STATE_UPDATE',
  // A follower reached a point where the server needs checking, asks the leader to do it
  CHECK_REQUEST = 'CHECK_REQUEST',
  // The server timed out the session, every tab reloads to show the inactivity message
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  // The user logged out, every tab signs out
  LOGOUT = 'LOGOUT',
}

export interface SessionBroadcastMessage extends BaseBroadcastMessage {
  channel: typeof SESSION_CHANNEL;
  type: SessionMessageType;
  payload?: {
    secondsRemaining?: number;
  };
}

export interface SessionState {
  secondsRemaining: number;
  // Date.now() when secondsRemaining was received
  timestamp: number;
}

export interface SessionTimeoutConfig {
  timeoutSeconds: number;
  warningOffsetSeconds: number;
}
